import { useSyncExternalStore } from 'react';

/** Phone layout (sheets instead of sidebars): narrow screens and phones in landscape (U32). */
export const PHONE_QUERY = '(max-width: 700px), (max-height: 500px)';

function mediaList(query: string): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;
}

/** Whether a CSS media query matches; re-renders on change (false where matchMedia is missing). */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = mediaList(query);
      if (!mql) return () => undefined;
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => mediaList(query)?.matches ?? false,
    () => false,
  );
}
